import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AsyncDownloadsService } from '@app-core/services/async-downloads/async-downloads.service';
import { DataService } from '@app-core/services/data/data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-download-schedule-modal',
  templateUrl: './download-schedule-modal.component.html',
  styleUrls: ['./download-schedule-modal.component.scss'],
})
export class DownloadScheduleModalComponent {
  public reportName: string;
  public downloadParams: any;

  constructor(
    private dialogRef: MatDialogRef<DownloadScheduleModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private asyncDownloadsService: AsyncDownloadsService,
    public dataService: DataService,
    public translate: TranslateService
  ) {
    this.reportName = data.reportName || 'Custom Report';
    this.downloadParams = data.downloadParams || {};
  }

  public onDownloadAnother(): void {
    this.dialogRef.close({ action: 'download_another' });
  }

  public onViewReport(): void {
    this.asyncDownloadsService.navigateToExportHistory(this.downloadParams.reportType);
    this.dialogRef.close({ action: 'view_report', params: this.downloadParams });
  }

  public onClose(): void {
    this.dialogRef.close(null);
  }
}
